import './accountSwitch.scss';
import React from 'react';

import { isSame } from '../../utils/util';
import { useState, useEffect, useContext, useCallback } from 'react';
import { AppContext } from '../../context/appContext';
import If from '../../common/components/if';
import { AccountOwner } from './components/accountOwner/accountOwner';
import { AccountCard } from './components/accountCard/accountCard';
import { AccountMenu } from './components/accountMenu/accountMenu';
import { RelatedAccountList } from './components/relatedAccountList/relatedAccountList';
import { SYSTEM } from '../../base/contextService';

export function AccountSwitch() {
    const appContext = useContext(AppContext);
    const [isEnterpriseAccount, setIsEnterpriseAccount] = useState(true);
    const { system } = appContext.state;
    const isSystemATES = system === SYSTEM.ATES;

    useEffect(() => {
        const enterpriseInfo = appContext.state.enterpriseInfo;
        setIsEnterpriseAccount(
            enterpriseInfo &&
                enterpriseInfo.enterprise_id &&
                !isSame(enterpriseInfo.enterprise_id, '0'),
        );
    }, []);

    return (
        <div className="account-switch">
            <If condition={isEnterpriseAccount}>
                <AccountOwner />
            </If>
            <If condition={!isEnterpriseAccount}>
                <div className='client-top-content'></div>
            </If>
            <div className="current-account-info">
                <AccountCard />
                <AccountMenu />
            </div>
            {!isSystemATES && <RelatedAccountList />}
        </div>
    );
}
